import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { nomiSport, sportDelProdotto } from "../../../../components/Util/sportProdotto";
import { VAT_OPTIONS, findVatOption } from '../../../../components/Util/vatOptions';

export const AdminCoursesEdit = () => {
    const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]



	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [bookingCourses] = await Promise.all([
                        apiClient.getBookingCourseById(token, id)
                    ]);
					setLoadingShowed(false);
                    
                    if(bookingCourses) {
                        const elementFormData = {
                            id: bookingCourses.id,
                            name: bookingCourses.name, 
                            sportTypes: sportDelProdotto(bookingCourses),
                            expiration_type: bookingCourses.expiration_type,
                            standard_price: bookingCourses.standard_price,
                            vat_rate: bookingCourses.vat_rate,
                            vat_nature: bookingCourses.vat_nature,
                            iva_5_percent: bookingCourses.iva_5_percent,
                            member_price: bookingCourses.member_price,
                            federated_price: bookingCourses.federated_price,
                            fitcoin_percentage: bookingCourses.fitcoin_percentage,
                            payable_in_club: bookingCourses.payable_in_club,
                            payable_stripe: bookingCourses.payable_stripe,
                            payable_bank: bookingCourses.payable_bank,
                            auto_renew: bookingCourses.auto_renew,
                            grants_club_membership: bookingCourses.grants_club_membership,
                            grants_federated_status: bookingCourses.grants_federated_status,
                            status: bookingCourses.status,
                            description: bookingCourses.description,
                            fitcoin_cashback: bookingCourses.fitcoin_cashback,
                            clubName: bookingCourses.clubName,
                            coursePicture: bookingCourses.coursePicture,
                            maxMembers: bookingCourses.maxMembers || 0,
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

    const [formData, setFormData] = useState({
        id: '',
        name: '', 
        sportTypes: [],
        expiration_type: '',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_percentage: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        auto_renew: false,
        grants_club_membership: false,
        grants_federated_status: false,
        status: '',
        coursePicture: ''
    });

    // Titolo della pagina = nome del corso, appena caricato.
    usePageTitle(formData?.name);

    // Stato nella tendina accanto al titolo: si salva subito (regola SUI). Il super admin lo cambia per
    // qualsiasi struttura; una bozza resta «Bozza» (si attiva dalla scheda della struttura).
    const cambiaStato = async (attiva) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const result = await apiClient.changeCourseStatus(token, id, nuovo);
        if (result && result.error) return { error: result.error };
        setFormData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: formData?.status === 'PURCHASABLE',
        bozza: formData?.status === 'DRAFT',
        onCambia: cambiaStato,
    });



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || false;
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Informazioni generali Corso</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6">
                                    <Form.Label>Struttura</Form.Label>
                                    <Form.Control disabled={formData.status!=='DRAFT'} 
                                        className="mt-2"
                                        style={formData.status!=='DRAFT' ? {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" } : {color: '#000000'}}
                                        placeholder='Inserisci Nome' type="text" name="name" value={formData.clubName} onChange={handleChange} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Nome corso</Form.Label>
                                    <Form.Control disabled
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal", fontSize: "14px" }}
                                        placeholder='Inserisci Nome' type="text" name="name" value={formData.name} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6">
                                    <Form.Label>Sport</Form.Label>
                                    <Form.Control disabled
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal", fontSize: "14px" }}
                                        type="text" name="sportTypes" value={nomiSport(formData)} readOnly />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Numero massimo di partecipanti</Form.Label>
                                    <Form.Control
                                        disabled
                                        className="mt-2"
                                        type="number"
                                        name="maxMembers"
                                        value={formData.maxMembers}
                                        onChange={handleChange}
                                        style={{
                                            color: 'rgba(108,117,125,0.6)', 
                                            backgroundColor: '#f2f2f2', 
                                            paddingLeft: "15px", 
                                            fontWeight: "normal"
                                        }}
                                    />
                                </Col>
                                <Col className="col-xl-6 text-center">
                                    <h4 className="text-center mb-0">Immagine del prodotto</h4>
                                    <br></br>
                                    {formData.coursePicture ? 
                                        <img src={formData.coursePicture} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                    : 
                                        'Nessuna immagine caricata'
                                    }
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-12">
                                    <Form.Label>Descrizione</Form.Label>
                                    <Form.Control 
                                        disabled
                                        rows={10} 
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        as="textarea" 
                                        name="description" 
                                        value={formData.description} 
                                        onChange={handleChange} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Prezzi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>Prezzo standard</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2"
                                        placeholder='Inserisci il prezzo standard' type="text" name="standard_price" value={formData.standard_price+' €'} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>IVA</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        value={findVatOption(formData)}
                                        options={VAT_OPTIONS}
                                    />
                                </Col>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>Prezzo riservato ai tesserati / soci</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2" 
                                        placeholder='Inserisci il prezzo riservato ai tesserati / soci' type="text" name="federated_price" value={formData.federated_price+' €'} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>Cashback Fitcoin</Form.Label>
                                    <Form.Control 
                                        disabled
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        placeholder='Inserisci il numero di fitcoin in cashback' 
                                        type="text" 
                                        name="fitcoin_percentage" 
                                        value={formData.fitcoin_cashback} 
                                        onChange={handleChange} />
                                </Col>
                            </Row>
                            {/*<Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Prezzo riservato ai soci</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2" 
                                        placeholder='Inserisci il prezzo riservato ai soci' type="text" name="member_price" value={formData.member_price+' €'} onChange={handleChange} />
                                </Col>
                            </Row>*/}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Condizioni aggiuntive</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile in struttura</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_in_club" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_in_club)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_in_club")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile su Stripe</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_stripe" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_stripe)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_stripe")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile con bonifico</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_bank" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_bank)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_bank")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                            
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-xl-3">
                    
                </div>
            </Row>
		</>
	)

}
export default AdminCoursesEdit;